export default __webpack_public_path__ + "static/media/LOCALSTACK.c225a9b9.png";